import { Component, Input, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { ProcedureService, ProcedureGroupModel, OrganizationLocation } from '@shopping';
import { TranslateService } from '@ngx-translate/core';
import { ShoppingSessionService } from '../../main/session.service';

@Component({
    selector: 'app-search-procedures',
    templateUrl: './search-procedures.component.html',
    styleUrls: ['./search-procedures.component.scss'],
    standalone: false
})
export class SearchProceduresComponent {

    public static modalName = 'searchProcedures';
    public procedures: any;

    @Input() public organizationName!: string;
    @Input() public locationId!: number;
    @Input() public selectedProcedures: ProcedureGroupModel[] = [];
    @Input() public searchMode = false;
    @Input() public procedureSearchConfig: any;
    @Output() public searchModeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public selectedProceduresChange: EventEmitter<ProcedureGroupModel[]> =
        new EventEmitter<ProcedureGroupModel[]>();
    @Output() public toggleContactMeModal: EventEmitter<string> = new EventEmitter<string>();

    private lastSearchFilter: string = '';

    constructor(
        private readonly translate: TranslateService,
        private readonly procedureService: ProcedureService,
        private readonly sessionService: ShoppingSessionService
    ) {

    }

    public onSearch(search: { name: string, filter: any; }) {
        const incomingFilter = (search.filter?.value ?? '').trim();

        if (!incomingFilter) {
            // Don't allow empty searches
            this.searchMode = false;
            this.searchModeChange.emit(this.searchMode);
            this.lastSearchFilter = '';

            return;
        }

        // The filter has not changed, don't search
        if (incomingFilter === this.lastSearchFilter.trim()) {
            return;
        }

        // This is a new search
        this.searchMode = true;
        this.searchModeChange.emit(this.searchMode);
        this.lastSearchFilter = incomingFilter;

        const query = this.lastSearchFilter;
        this.procedureService.procedureApiControllerGetAll(
            this.sessionService.sessionId,
            undefined, undefined,
            query,
            this.locationId
        ).pipe(
            map((data: any) => {
                Object.keys(data.language).forEach(lang => this.translate.setTranslation(lang, data.language[lang], true));

                return data.config;
            })
        )
            .subscribe((data: ProcedureGroupModel[]) => {
                const selectedProcedures = this.selectedProcedures.map((procedure) => procedure.id);

                this.procedures = data.filter(pg => {
                    const locations = (pg as any).locations;
                    const locationMatch = locations.find((location: OrganizationLocation) => location.id === this.locationId);

                    if (!locations.length || locationMatch || !this.locationId) return pg;
                }).map(procedureGroup => {
                    return {
                        ...procedureGroup,
                        selected: selectedProcedures.includes(procedureGroup.id),
                        open: false,
                        procedures: procedureGroup.proceduresAreVisible ? procedureGroup.procedures : [procedureGroup.procedures[0]]
                    };
                });
            });
    }

    public toggleProcedure(selected: boolean, group: ProcedureGroupModel): void {
        const selectedProcedures = this.selectedProcedures.map((procedure) => procedure.id);
        const index = selectedProcedures.indexOf(group.id);

        if (!selected && index !== -1) {
            this.selectedProcedures.splice(index, 1);
        }

        if (selected && index === -1) {
            this.selectedProcedures.push(group);
        }

        group.selected = selected;
        this.selectedProceduresChange.emit(this.selectedProcedures);
    }

    public showContactMeModal() {
        this.toggleContactMeModal.emit(this.lastSearchFilter);
    }

    public backToCategories(): void {
        this.searchMode = false;
        this.searchModeChange.emit(this.searchMode);
    }
}
